module.exports = __webpack_public_path__ + "static/media/Logo-HCMIU.4c2f6904.svg";